"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKongAccessToken = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const AUTH_PROXY_COOKIES = {
    staging: {
        AUTH_PROXY_COOKIE_OAUTH: 'OAuth2TokenStage',
        AUTH_PROXY_COOKIE_SESSION: 'SessionTokenStage'
    },
    production: {
        AUTH_PROXY_COOKIE_OAUTH: 'OAuth2Token',
        AUTH_PROXY_COOKIE_SESSION: 'SessionToken'
    }
};
const setApiEnvVariables = (environment) => {
    switch (environment) {
        case 'staging':
            return {
                authProxyOauthCookieName: AUTH_PROXY_COOKIES.staging.AUTH_PROXY_COOKIE_OAUTH,
                authProxyCookieSessionName: AUTH_PROXY_COOKIES.staging.AUTH_PROXY_COOKIE_SESSION
            };
        case 'test':
            return {
                authProxyOauthCookieName: AUTH_PROXY_COOKIES.staging.AUTH_PROXY_COOKIE_OAUTH,
                authProxyCookieSessionName: AUTH_PROXY_COOKIES.staging.AUTH_PROXY_COOKIE_SESSION
            };
        case 'production':
            return {
                authProxyOauthCookieName: AUTH_PROXY_COOKIES.production.AUTH_PROXY_COOKIE_OAUTH,
                authProxyCookieSessionName: AUTH_PROXY_COOKIES.production.AUTH_PROXY_COOKIE_SESSION
            };
        default:
            return {
                authProxyOauthCookieName: AUTH_PROXY_COOKIES.production.AUTH_PROXY_COOKIE_OAUTH,
                authProxyCookieSessionName: AUTH_PROXY_COOKIES.production.AUTH_PROXY_COOKIE_SESSION
            };
    }
};
const setBasePath = (environment) => {
    switch (environment) {
        case 'staging':
            return 'https://staging.www.koodomobile.com';
        case 'test':
            return 'https://test.www.koodomobile.com';
        case 'production':
            return 'https://www.koodomobile.com';
        default:
            return 'https://www.koodomobile.com';
    }
};
const tokenMap = new Map();
const getKongAccessToken = async ({ environment, scope, cookies }) => {
    if (tokenMap.has(scope)) {
        const accessToken = tokenMap.get(scope);
        if (accessToken && accessToken.expires_at > Date.now()) {
            return accessToken;
        }
    }
    const { authProxyOauthCookieName, authProxyCookieSessionName } = setApiEnvVariables(environment);
    const basePath = setBasePath(environment);
    const response = await axios_1.default
        .post(`${basePath}/my-account/kong/auth/api/access-token`, { scope }, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            credentials: 'include',
            cookie: `${authProxyOauthCookieName}=${cookies[authProxyOauthCookieName]}; ` +
                `${authProxyCookieSessionName}=${cookies[authProxyCookieSessionName]}`
        }
    })
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        return error;
    });
    if (response.type === 'error') {
        return response;
    }
    tokenMap.set(scope, response);
    return response;
};
exports.getKongAccessToken = getKongAccessToken;
//# sourceMappingURL=getKongAccessToken.js.map